import ComparisonResultCategory from '../../../entities/ComparisonResultCategory'

const getColumnCount = (categories: ComparisonResultCategory[]): number => {
    const modelCategory = categories.find(cat => cat.id === 'model')
    const firstSubcategoryWithRows = modelCategory?.subCategory.find(sub => sub.rows.length > 0)
    return firstSubcategoryWithRows?.rows[0]?.columns.length || 0
}

export default getColumnCount
